export var ErrorType;
(function (ErrorType) {
    ErrorType["ActivationError"] = "activate";
    ErrorType["DeactivationError"] = "deactivate";
    ErrorType["PlaceError"] = "place";
    ErrorType["StakeError"] = "stake";
    ErrorType["PurchaseError"] = "purchase";
    ErrorType["IncompatibleSelectionsError"] = "incompatibleSelections";
})(ErrorType || (ErrorType = {}));
//# sourceMappingURL=ErrorType.js.map